import React from 'react'

import Icon from '../../../../../../../../components/Icon'
import { ReactComponent as CheckedCircle } from '../../../../../../../../assets/icons/checked-circle.svg'

import useStyles from './styles'

const UploadedMediaIcon = ({ isSuccess }) => {
  const classes = useStyles()

  return isSuccess ? (
    <Icon className={classes.icon}>
      <CheckedCircle />
    </Icon>
  ) : (
    <span className={classes.emptyIcon} />
  )
}

export default UploadedMediaIcon
